<template>
    <v-container>
        <v-row justify="center">
            <v-col
                cols="12"
                md="8"
            >
                <v-card class="pa-5 ma-5">
                    <h1>
                        Terms and Conditions
                    </h1>
                    <div>
                        <p class="body-2">
                            Last Updated: 08/21/2019
                        </p>
                        <p>
                            Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using the https://comeconnect.me website  operated by Vrume, LLC ("us", "we", or "our").
                        </p>
                        <p>
                            Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.
                        </p>
                        <b>
                            By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.
                        </b>
                    </div>
                    <div>
                        <h2 class="title">
                            Content
                        </h2>
                        <p>
                            Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material ("Content"). You are responsible for keeping this information up to date as you choose. The material posted on Come Connect is public, by accepting our service you recognize that the information and links you post will be accessible by anyone.
                        </p>
                    </div>
                    <div>
                        <h2 class="title">
                            Links To Other Web Sites
                        </h2>
                        <p>
                            Our Service may contain links to third-party web sites or services that are not owned or controlled by Vrume LLC.
                        </p>
                        <p>
                            Vrume, LLC has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that Vrume, LLC shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.
                        </p>
                    </div>
                    <div>
                        <h2 class="title">
                            Changes
                        </h2>
                        <p>
                            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 (change this) days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
                        </p>
                    </div>
                    <div>
                        <h2 class="title">
                            Contact Us
                        </h2>
                        <p>
                            If you have any questions about this Terms and Conditions document, please contact us at <a href="mailto:support@comeconnect.me">support@comeconnect.me</a>
                        </p>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'TermsAndConditions'
}
</script>
